import { styled, Switch, switchClasses } from '@mui/material';

export const AssistantGenerateRoutesDialogScheduleRouteCardTitleSwitch = styled(
  Switch,
)(({ theme }) => ({
  overflow: 'visible',

  [`&.pulse .${switchClasses.switchBase} + .${switchClasses.track}`]: {
    position: 'relative',

    '&:before, &:after': {
      content: '""',
      boxShadow: `0 0 0 0 ${theme.palette.primary.light}`,
      opacity: 0.7,
      animation: 'pulseKeyFrames 1.3s infinite',
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: 'inherit',
    },

    '&:after': {
      animationDelay: '0.3s',
    },
  },

  '@keyframes pulseKeyFrames': {
    '100%': {
      boxShadow: `0 0 0 10px currentColor`,
      opacity: 0,
    },
  },
}));
